import { useEffect, useState } from 'react';
import sleep from 'sleep-promise';

import { ALL_FILTERS_ELEMENT } from 'modules/utils/constants';
import { API, api } from 'modules/api';
import { filterType, ResourceHubLoadedType } from '../types';
import { LoginTypeEnum } from 'modules/utils/types';
import { slugIsFilter } from '../utils';
import logger from 'modules/logger';

export const useResourceHub = (
  setLoaded: React.Dispatch<React.SetStateAction<ResourceHubLoadedType>>,
  pathname: string,
  loaded: boolean,
  loginTypeContext?: LoginTypeEnum,
) => {
  const [bestPractices, setBestPractices] = useState<filterType>({ data: [] });
  const [contentTypes, setContentTypes] = useState<filterType>({ data: [] });

  const [topics, setTopics] = useState<filterType>({ data: [] });

  useEffect(() => {
    //TODO done useEffect
    let active = true;
    (async () => {
      try {
        const startTime = performance.now();

        // api(
        //   API.GET_CONTENT_FROM_CONTENT_STACK(
        //     `get-categories-by-cmscategory/${
        //       loginTypeContext !== undefined ? loginTypeContext : ''
        //     }`,
        //   ),
        // ).then(res => {
        //   res?.data.multipleObjectParentModels[0].listItemModels.unshift(
        //     ALL_FILTERS_ELEMENT,
        //   );
        //   setContentTypes(res.data);
        // });

        // api(
        //   API.GET_CONTENT_FROM_CONTENT_STACK(
        //     `get-resource-types-by-cms/${
        //       loginTypeContext !== undefined ? loginTypeContext : ''
        //     }`,
        //   ),
        // ).then(res => {
        //   res?.data.multipleObjectParentModels[0].listItemModels.unshift(
        //     ALL_FILTERS_ELEMENT,
        //   );
        //   setTopics(res?.data);
        // });

        api(
          API.GET_CONTENT_FROM_CONTENT_STACK(
            `get-certificates-by-cms/${
              loginTypeContext !== undefined ? loginTypeContext : ''
            }`,
          ),
        ).then(res => {
          const data = transformData(
            res?.data.multipleObjectParentModels[0].listItemModels,
          );
          // res?.data?.data?.unshift(ALL_FILTERS_ELEMENT);
          // console.log('data', res?.data?.data);
          data?.data?.unshift(ALL_FILTERS_ELEMENT);
          setBestPractices(data);
        });

        // api(
        //   API.GET_CONTENT_FROM_CONTENT_STACK(
        //     `get-certificates-by-slug/${
        //       loginTypeContext !== undefined ? loginTypeContext : ''
        //     }`,
        //   ),
        // ).then(res => {
        //   // const data = transformData(
        //   //   res?.data.multipleObjectParentModels[0].listItemModels,
        //   // );
        //   res?.data?.data?.unshift(ALL_FILTERS_ELEMENT);
        //   console.log('data', res?.data?.data);
        //   setBestPractices(res?.data);
        // });

        if (active) {
          const endTime = performance.now();
          if (endTime - startTime < 400) {
            await sleep(250);
          }
        }
      } catch (error) {
        active && logger.error('Get Filters Error', error);
      } finally {
        active &&
          setLoaded(prevState => ({
            ...prevState,
            filters: true,
          }));
      }
    })();
    return () => {
      active = false;
    };
  }, [loginTypeContext, setLoaded]);

  useEffect(() => {
    setLoaded(prevState => ({
      ...prevState,
      contentType: false,
    }));
    if (pathname.replace(/\/$/, '').split('/').length === 4 && loaded) {
      const result = slugIsFilter(
        bestPractices,
        contentTypes,
        pathname.replace(/\/$/, '').split('/')[3].split(',')[0],
        topics,
      );
      setLoaded(prevState => ({
        ...prevState,
        contentType: !result,
      }));
    }
  }, [pathname, bestPractices, contentTypes, topics, loaded, setLoaded]);

  const transformData = (listItemModels: any) => {
    const data = listItemModels.map((item: any) => ({
      uid: item.rowKey.toLowerCase(),
      title: item.itemValue,
      slug: item.itemValue,
    }));

    return {
      data,
      entries: null,
    };
  };

  return {
    resources: {
      bestPractices,
      setBestPractices,
      contentTypes,
      setContentTypes,
      topics,
      setTopics,
    },
  };
};
